import { bpoints } from "../../../../Utils";


export const styles = `
.preloan-dialog .p-dialog-header {
    padding: 0;
}

/* Colores del botón */
        .Green {
            background-color: #22ec9a !important;
            color: white !important;
            &:hover {
                background-color: #2ad690 !important;
                color: white !important;
            }
        }

        .Button {
            border-radius: 17px !important;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            &:hover {
                border: none !important;
            }
            
        }

        .Blue {
            background-color: #32b8df !important;
            color: white !important;
            &:hover {
                background-color: #2da5c8 !important;
                color: white !important;
            }
        }

.preloan-dialog .p-dialog-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
}
.preloan-dialog-header-content {
    background: linear-gradient(to right, #0891b2, #06b6d4);
    color: white;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.preloan-dialog-header-content h2 {
    font-size: 1.25rem;
    font-weight: 700;
}
.preloan-close-button.p-button {
    color: white !important;
    background: transparent !important;
}
.preloan-close-button.p-button:hover {
    background-color: rgba(255, 255, 255, 0.2) !important;
}
.preloan-stepper-container {
    padding: 1.5rem; /* p-6 */
    border-bottom: 1px solid #e5e7eb; /* border-b */
}
.preloan-content-area {
    flex: 1;
    overflow-y: auto;
    padding: 1.5rem; /* p-6 */
}
.preloan-content-area h3 {
    font-size: 1.125rem; /* text-lg */
    font-weight: 600; /* font-semibold */
    color: #111827; /* text-gray-900 */
    margin-bottom: 0.5rem; /* mb-2 */
}
.preloan-content-area p {
    font-size: 0.875rem; /* text-sm */
    color: #4b5563; /* text-gray-600 */
}
.preloan-dialog-footer {
    
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.preloan-step-indicator {
    font-size: 0.875rem;
    color: #4b5563;
}
.preloan-finish-button.p-button {
    background-color: #16a34a !important;
    color: white !important;
}
.preloan-finish-button.p-button:hover {
    background-color: #15803d !important;
}
      .TextInput{
    background-color: transparent;
    border-radius: 17px;
    border-color: #34C6F1;
    border-width: 1.5px;
    width: 100%;
    padding: 1rem 1.4rem;

    font-family: 'Neue Haas Grotesk Display Pro' !important;
    font-size: calc(0.2rem + 1vw);
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.46px;
    color: black;
    
    @media (max-width: ${bpoints.tablet.w}px){
        font-size: calc(0.8rem + 1vw);
    }

    ::placeholder{
        font-weight: 500;
        color: #A7A9AC;
    }

}

/* Estilo para asteriscos de campos requeridos */
.required-asterisk {
    color: #ff0000;
    font-weight: bold;
    margin-left: 2px;
}

.TextInputError{
    border-color: #ff0000;  
     background-color: transparent;
    border-radius: 17px;
    border-width: 1.5px;
    width: 100%;
    padding: 1rem 1.4rem;

    font-family: 'Neue Haas Grotesk Display Pro' !important;
    font-size: calc(0.2rem + 0.9vw);
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.46px;
    color: black;
    
    @media (max-width: ${bpoints.tablet.w}px){
        font-size: calc(0.8rem + 1vw);
    }

    ::placeholder{
        font-weight: 500;
        color: #A7A9AC;
    }

}

`;